import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { MODALS } from '../../constants';
import { ModalState } from '../../recoil/modal/modal.state';
import CreateChannelModal from '../modal/create-channel.modal';
import EditProfileModal from '../modal/edit-profile.modal';
import ShareModal from '../modal/share.modal';
import ModalController from '../utility/modal-controller';

export default function Modals() {
  const set = useSetRecoilState(ModalState);

  const handleClose = () => {
    set((prev) => ({ ...prev, shouldShow: false, current: null }));
  };

  useEffect(() => {
    const handleEsc = (event: any) => {
      if (event.keyCode === 27) {
        handleClose();
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, []);

  return (
    <ModalController modals={MODALS}>
      <ModalController.Modal name="EDIT_PROFILE">
        <EditProfileModal />
      </ModalController.Modal>
      <ModalController.Modal name="SHARE">
        <ShareModal />
      </ModalController.Modal>
      <ModalController.Modal name="CREATE_CHANNEL">
        <CreateChannelModal />
      </ModalController.Modal>
    </ModalController>
  );
}
